import { Injectable } from '@angular/core';
import { OnFinish } from 'src/app/rokezzz/api/api/on-finish';
import { HttpErrorResponse } from '@angular/common/http';
import { UploadedFile } from '../api/uploaded-file';
import { RokezzzApiService } from 'src/app/rokezzz/api/services/api.service';
import { ApiFilterConfig } from '../../api/api/api-filter-config';
import { ApiResponse } from '../../api/api/api-response';

@Injectable({
    providedIn: 'root'
})
export class RokezzzFileUploaderService {
    public readonly apiPath: string = 'uploadedFiles';

    public constructor(
        protected readonly rokezzzApiService: RokezzzApiService,
    ) { }

    public getIRI(id: number): string {
        return this.rokezzzApiService.apiUrl + this.apiPath + '/' + id;
    }

    public getIdFromIRI(iri: string): number {
        return parseInt(iri.split('/').pop() as string);
    }

    public getCollection(
        apiFilterConfig: ApiFilterConfig,
        onSuccess: OnFinish<ApiResponse<UploadedFile>>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.getCollection(
            this.apiPath,
            {},
            apiFilterConfig,
            onSuccess,
            onError,
        );
    }

    public getCollectionAll(
        apiFilterConfig: ApiFilterConfig,
        onSuccess: OnFinish<ApiResponse<UploadedFile>>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.getCollection(
            this.apiPath + '/all',
            {},
            apiFilterConfig,
            onSuccess,
            onError
        );
    }

    public getById(
        id: number,
        onSuccess: OnFinish<UploadedFile>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.get(
            this.apiPath + '/' + id,
            {},
            onSuccess,
            onError
        );
    }

    public uploadImage(
        file: File,
        onSuccess: OnFinish<UploadedFile>,
        onError: OnFinish<HttpErrorResponse>,
        title?: string
    ): void {
        this.uploadFile(
            'image',
            file,
            onSuccess,
            onError,
            title
        );
    }

    public delete(
        id: number,
        onSuccess: OnFinish<void>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.delete(
            this.apiPath + '/' + id,
            {},
            onSuccess,
            onError
        );
    }

    private uploadFile(
        endpoint: string,
        file: File,
        onSuccess: OnFinish<UploadedFile>,
        onError: OnFinish<HttpErrorResponse>,
        title?: string,
    ): void {
        const formData: FormData = new FormData();

        formData.append('file', file);

        if (title) {
            formData.append('title', title);
        }

        this.rokezzzApiService.setMultipartContentType();
        this.rokezzzApiService.post(
            this.apiPath + '/' + endpoint,
            formData,
            onSuccess,
            onError
        );
    }

    public getImageSrc(name: string): string {
        return this.rokezzzApiService.apiUrl + 'images/' + name + '/file';
    }
}
